import React, { useEffect, useState } from "react";
import { Col, Row} from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
    numberFormat,
    getTodayDate,
    getType,
    getBranchId,
    selectDropdownStyle,
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";

import { searchTransferHistory } from "../../../Helpers/apiCalls/Reports/TransferHistoryApi";
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import { getAllItems } from "../../../Helpers/apiCalls/itemsApi";
import Footer from "../../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination";


export default function TransferHistory() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
        page: 1
    })
    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [expenses, setExpenses] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState([]);
    const [totalTransfers, setTotalTransfers] = useState([]);
    const [items, setItems] = useState([]);
    const xlsxHeaders =  [ "Total Transfers", "Total Quantity", "Item Name", "Unit", "Quantity", "Branch From", "Branch To" ]
    
    const [branchFrom, setBranchFrom] = useState("");
    const [branchTo, setBranchTo] = useState("");
    const [excelData, setExcelData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function handleItemChange(e){
        const toFilter = {target: {name: "item_id", value: e.value}};
        handleOnSearch(toFilter);
    }

    function handleBranchFromChange(e){
        setBranchFrom(e.name);
        const toFilter = {target: {name: "branch_from", value: e.value}};
        handleOnSearch(toFilter);
    }

    function handleBranchToChange(e){
        setBranchTo(e.name);
        const toFilter = {target: {name: "branch_to", value: e.value}};
        handleOnSearch(toFilter);
    }

    async function fetchBranches() {
        setShowLoader(true);

        const response = await getAllBranches();
        if (response.error) {
        } else {
            var allBranches = response.data.data.data.map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });
            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = allBranches.filter((data) => {
                return data.id === getBranchId()
                })
                setBranches(filteredBranch);
            } else {
                setBranches([{label: "All Branches", value:""}, ...allBranches]);
            }
        }
        setShowLoader(false);
    }

    async function fetchAllItems() {
        const response = await getAllItems();

        if (response.response.data) {
            var data = response.response.data.map((item) => {
                var info = item;
                info.label = item.name
                info.value = item.id
                return info;
            });
            setItems([{label: "All Items", value:""}, ...data]);
        } else {
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setExpenses([])
        setExcelData([])
        setTotalItems(0)
        var allData = [];
        var allExcel = [];
        var total = {
            total_transfers: "",
            total_quantity: "",
        }

        const response = await searchTransferHistory(filterConfig);

        if (response.data) {
            setTotalItems(response.data.size);
            var allBills = response.data.data.map((bill) => {
                var info = bill;
                info.transfer_date = Moment(bill.transfer_date).format("MMM DD, YYYY")
                info.receive_date = Moment(bill.receive_date).format("MMM DD, YYYY")
                info.total_qty = numberFormat(bill.total_qty)
                allData.push(info);
                return info;
            });

            var totaltransfers = response.data.summary? response.data.summary.total_transfers : "0";
            var totalqty = response.data.summary? response.data.summary.total_qty : "0";
            total["total_transfers"] = numberFormat(totaltransfers);
            total["total_quantity"] = numberFormat(totalqty);
            setTotalTransfers(totaltransfers);
            setTotalQuantity(totalqty);
            
            var excel = allBills.map((bill) => {
                var info = {};
                info.total_transfers = bill.total_transfers
                info.total_quantity = bill.total_quantity
                info.name = bill.name
                info.unit = bill.unit
                info.total_qty = bill.total_qty
                info.source_branch = bill.source_branch
                info.destination_branch = bill.destination_branch
                allExcel.push(info);
                return info;
            });
        }

        setExpenses(allData)
        setExcelData([total, ...allExcel])
        setShowLoader(false);
    }

    function handleExport() {
        const rows = excelData
        
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
        XLSX.writeFile(workbook, "TransferHistory.xlsx", { compression: true });
    }

    useEffect(() => {
        fetchBranches();
        fetchAllItems();
    }, []);

    useEffect(() => {
        fetchData();
    }, [filterConfig, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"TRANSFERS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={8}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> TRANSFER HISTORY </h1>
                    </Col>
                </Row>

                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                    <Col xs={12} lg={3} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Item"
                            styles={selectDropdownStyle}
                            // value={branch}
                            options={items}
                            onChange={handleItemChange}
                        />
                    </Col>
                    <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Branch From"
                            styles={selectDropdownStyle}
                            // value={branchFrom}
                            options={branches}
                            onChange={handleBranchFromChange}
                        />
                    </Col>
                    <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Branch To"
                            styles={selectDropdownStyle}
                            // value={branchTo}
                            options={branches}
                            onChange={handleBranchToChange}
                        />
                    </Col>
                    <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={"Select Date"}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                    </Col>
                    <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={"Select Date"}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                    </Col>
                    </Row>
                    <div className="mb-2" />

                    <div className="my-2 px-2 PO-filters d-flex justify-content-center">

                        <span className="me-4 ml-4 align-middle mt-2 ps-label">
                            Total Transfers: {numberFormat(totalTransfers)}
                        </span>

                        <span className="me-4 ml-8 align-middle mt-2 ps-label">
                            Total Quantity: {numberFormat(totalQuantity)}
                        </span>
                    </div>

                    <div className="below">
                        {/* table */}
                        <TableWithDynamicPagination
                            tableHeaders={[
                                "TRANSFER DATE",
                                "RECEIVE DATE",
                                "ITEM NAME",
                                "UNIT",
                                "QTY",
                                "BRANCH FROM",
                                "BRANCH TO",
                            ]}
                            headerSelector={[
                                "transfer_date",
                                "receive_date",
                                "name",
                                "unit",
                                "total_qty",
                                "source_branch",
                                "destination_branch",
                            ]}
                            tableData={expenses}
                            showLoader={showLoader}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
                <div className="mb-3" />
<br /><br />
                <Row>
                    <Col lg={10} className="mt-3 mt-lg-0"></Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                    <div className="PO-filters">
                        <button
                            type="button"
                            className="primary-btn"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon} alt=""
                                ></img>
                            </span>
                            Download
                        </button>
                    </div>
                    </Col>
                </Row>
                <div className="mb-3" />
                <br /><br />
            </div>
            <Footer/>
        </div>
    );
}
